<template>
	<div class="section">
		<div class="is-pulled-right">
			<nav class="breadcrumb" aria-label="breadcrumbs">
				<ul>
					<li v-for="(row, index) in data" :key="index" :class="{'is-active': (data.length - 1) === index}"><router-link :to="row.path">{{row.title}}</router-link></li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: ['data']
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/breadcrumbs.vue